import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useTheme } from '../../context/ThemeContext'
import clsx from 'clsx'
import { useFormik } from 'formik';
import * as Yup from 'yup';

type Props = {
    showModal: boolean
    closeModal: () => void
    envelope: any
    loading: boolean
    onVoidHandler: (reason: string) => void
    errorMessage: string
    message: string
}
const validationSchema = Yup.object().shape({
    reason: Yup.string().min(3, 'Atleast 3 words are required').max(500,'Maximum 500 words allowed').required('Reason is required')
});

const VoidEnvelopeModal: React.FC<Props> = ({
    showModal,
    closeModal,
    envelope,
    loading,
    onVoidHandler,
    errorMessage,
    message,
}: Props) => {
    const { theme } = useTheme()
    const initialValues = {
        reason: '',
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            onVoidHandler(values?.reason)
        }
    })
    return (
        <Modal
            contentClassName={theme === 'dark' ? 'theme__div' : ''}
            show={showModal}
            onHide={closeModal}
        >
            <Modal.Header>
                <Modal.Title
                    className={`text-truncate ${theme === 'dark' ? 'theme__div' : ''}`}
                >{`Void "${envelope?.documentName?.trim()}"`}</Modal.Title>
                <i
                    className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`}
                    onClick={closeModal}
                ></i>
            </Modal.Header>
            <form onSubmit={formik.handleSubmit}>
                <Modal.Body style={{ wordBreak: 'break-all' }}>
                    <span className={theme === 'dark' ? 'white__text' : ''}>
                        Are you sure you want to void this envelope?
                    </span>
                    <div className=' col-12 '>
                        <div className={`fs-5 fw-semibold mt-3 ${theme === 'light' ? 'dark__text' : ''}`}>
                            {' '}
                            Reason
                        </div>
                        <textarea
                            placeholder='Enter Reason'
                            autoComplete='off'
                            rows={5}
                            {...formik.getFieldProps('reason')}
                            className={clsx(
                                `form-control form-control-lg form-control-solid  ${theme === 'dark' ? 'dark__theme__input' : ''
                                }  italics-placeholder mt-2`,
                                {
                                    'is-invalid': formik.touched.reason && formik.errors.reason,
                                },
                                {
                                    'is-valid': formik.touched.reason && !formik.errors.reason,
                                }
                            )}
                        />
                        {formik.touched.reason && formik.errors.reason && (
                            <div className='fv-plugins-message-container mt-1'>
                                <div className='fv-help-block'>
                                    <span role='alert' className='text-danger'>
                                        {formik.errors.reason as any}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    <Alert variant='warning' className='mb-0 w-100 my-3'>
                        <i className="bi bi-exclamation-circle me-2 text-warning"></i>
                        <span className='fw-bold'>This action is irreversible</span>. Once voided, an envelope cannot be reactivated. You&apos;ll need to create a new envelope to start over.
                    </Alert>

                    {message && (
                        <Alert variant='success' className='mb-0 w-100 my-2'>
                            {message}!
                        </Alert>
                    )}
                    {errorMessage && (
                        <Alert variant='danger' className='mb-0 w-100 my-2'>
                            {errorMessage}!
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div
                        className={`${theme === 'dark' ? 'white__text' : ''
                            } d-flex justify-content-end w-100 align-items-center`}
                    >
                        <Button variant='secondary mx-2' onClick={closeModal}>
                            No
                        </Button>
                        <Button disabled={loading || formik.isSubmitting} variant='primary' type='submit'>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>

            </form >
        </Modal >
    )
}

export default VoidEnvelopeModal


